<template>
    <div id="add-order-line-page">
        <add-order-line
            @finished="goBack"
            :profile-id-param="profileIdParam"
            :product-id-param="productIdParam"></add-order-line>
    </div>
</template>
<script>
import AddOrderLine from '../components/orderLines/AddOrderLine';
export default {
    components: { AddOrderLine },
    computed: {
        profileIdParam() {
            return this.$route.query.profileId;
        },
        productIdParam() {
            return this.$route.query.productId || null;
        },
        returnToParam() {
            return this.$route.query.returnTo || '/stockcount';
        },
    },
    methods: {
        goBack(isCancel) {
            this.$router.push(this.returnToParam);
        },
    },
};
</script>
